import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { CmdTooltip } from '@commander-services/gui-components';
import { IS_ALARM_LAYER, IS_ECO_DRIVE_LAYER, IS_EVENT_LAYER, IS_RIDE_LAYER } from './constants';
import {
  IRidePlayerTimelineAlarmLayer,
  IRidePlayerTimelineEcoDriveLayer,
  IRidePlayerTimelineSpeedlimitLayer,
} from './types';
import { activeRideIndexAtom, selectedRidesAtom } from './RidePlayerState';

export interface IDisabledTimelineLayer {
  permissions: boolean;
  gdpr: boolean;
}

interface ITimelineLayerProps {
  layer: string;
  activeLayer: string;
  selectCallback: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isDisabled?: IDisabledTimelineLayer;
  data:
    | IRidePlayerTimelineEcoDriveLayer
    | IRidePlayerTimelineSpeedlimitLayer
    | IRidePlayerTimelineAlarmLayer
    | null;
  showLayerData: boolean;
  enableSpeedlimits?: boolean;
  handleTimelineTrackRef?: (ref: HTMLDivElement | null) => void;
  icon?: JSX.Element;
  title: string;
  color: string;
  tooltipPlacement?: string;
}

export default function TimelineLayer(props: ITimelineLayerProps): JSX.Element {
  const handleOnClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!props.isDisabled?.gdpr && !props.isDisabled?.permissions) {
      props.selectCallback(event);
    }
  };

  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];
  return (
    <CmdTooltip
      content={props.title ? <div style={{ minWidth: '300px' }}>{props.title}</div> : ''}
      style={{ display: 'block' }}
      width={300}
      isTop={props.tooltipPlacement === 'top'}
    >
      <div
        className={`item ${props.color} ${props.activeLayer !== props.layer ? 'opacity-5' : ''}`}
        onClick={
          props.isDisabled?.gdpr === true || props.isDisabled?.permissions === true
            ? undefined
            : handleOnClick
        }
      >
        <div
          className="start"
          style={
            props.isDisabled?.gdpr || props.isDisabled?.permissions
              ? { background: '#E5E5E5' }
              : undefined
          }
        >
          {props.icon || ''}
        </div>
        <div
          className="progress-bar"
          ref={props.handleTimelineTrackRef || null}
          style={
            props.isDisabled?.gdpr || props.isDisabled?.permissions
              ? { background: '#E5E5E5', textAlign: 'center' }
              : undefined
          }
        >
          {props.isDisabled?.gdpr && (
            <img
              src={new URL('/assets/images/player/Gdpr.svg', import.meta.url).href}
              style={{ marginTop: '-1.5rem' }}
              alt=""
              title=""
            />
          )}
          {props.layer === IS_ECO_DRIVE_LAYER &&
            props.showLayerData &&
            props.data &&
            props.data[activeRideNumber] &&
            Object.keys(props.data[activeRideNumber]).map((positionNumber: string) => {
              if (props.data) {
                return (
                  <div
                    key={`${props.layer}-position-${activeRideNumber}-${positionNumber}`}
                    className="pb-item"
                    style={{
                      width: `${props.data[activeRideNumber][positionNumber][2]}%`,
                      left: `${props.data[activeRideNumber][positionNumber][0]}%`,
                      backgroundColor: `${props.data[activeRideNumber][positionNumber][1]}`,
                    }}
                  />
                );
              }
              console.warn('Error rendering layer: ', props.layer);
              return null;
            })}
          {props.layer === IS_RIDE_LAYER &&
            props.showLayerData &&
            props.data &&
            props.data[activeRideNumber] &&
            props.enableSpeedlimits &&
            Object.keys(props.data[activeRideNumber]).map((positionNumber: string) => {
              if (props.data) {
                return (
                  <div
                    key={`${props.layer}-position-${activeRideNumber}-${positionNumber}`}
                    className="pb-item"
                    style={{
                      width: `${props.data[activeRideNumber][positionNumber][2]}%`,
                      left: `${props.data[activeRideNumber][positionNumber][0]}%`,
                      backgroundColor: `${props.data[activeRideNumber][positionNumber][1]}`,
                    }}
                  />
                );
              }
              console.warn('Error rendering layer: ', props.layer);
              return null;
            })}
          {props.layer === IS_ALARM_LAYER &&
            props.showLayerData &&
            props.data &&
            props.data[activeRideNumber] &&
            Object.keys(props.data[activeRideNumber]).map((positionNumber: string) => {
              if (props.data) {
                return (
                  <div
                    key={`${props.layer}-position-${activeRideNumber}-${positionNumber}`}
                    className="pb-item"
                    style={{
                      width: `${props.data[activeRideNumber][positionNumber][1]}%`,
                      left: `${props.data[activeRideNumber][positionNumber][0]}%`,
                      backgroundColor: '#b50536',
                    }}
                  />
                );
              }
              console.warn('Error rendering layer: ', props.layer);
              return null;
            })}
          {props.layer === IS_EVENT_LAYER &&
            props.showLayerData &&
            props.data &&
            props.data[activeRideNumber] &&
            Object.keys(props.data[activeRideNumber]).map((positionNumber: string) => {
              if (props.data) {
                return (
                  <div
                    key={`${props.layer}-position-${activeRideNumber}-${positionNumber}`}
                    className="pb-item"
                    style={{
                      width: `${props.data[activeRideNumber][positionNumber][1]}%`,
                      left: `${props.data[activeRideNumber][positionNumber][0]}%`,
                      backgroundColor: '#0d336f',
                    }}
                  />
                );
              }
              console.warn('Error rendering layer: ', props.layer);
              return null;
            })}
        </div>
      </div>
    </CmdTooltip>
  );
}
